export default "__VITE_ASSET__BY9UHV3w__"